import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconMultipleAnswers = ({ color = 'var(--color-semantic-3)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.4" x="1" y="1" width="18" height="18" rx="3" stroke={color} strokeWidth="2"/>
        </svg>
    </div>
);

export default IconMultipleAnswers;
